import { render } from "./SourceUpgrades.vue?vue&type=template&id=caf78172&scoped=true"
import script from "./SourceUpgrades.vue?vue&type=script&lang=js"
export * from "./SourceUpgrades.vue?vue&type=script&lang=js"

import "./SourceUpgrades.vue?vue&type=style&index=0&id=caf78172&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf78172"]])

export default __exports__